export default __webpack_public_path__ + "static/media/500.8a052c36.svg";